<div class="services-page">
  @if (loading) {
    <app-loader></app-loader>
  }

  <section class="overview-hero">
    <div class="hero-copy">
      <span class="hero-kicker">Service Catalog</span>

      <h1>Manage <span>Services</span></h1>

      <p>
        Manage salon categories, pricing, duration, service availability, and
        assigned locations from one clean workspace.
      </p>

      <div class="salon-scope-pill">
        <span>Salon view</span>

        <strong>
          {{ salonContext.selectionLabel() }}
        </strong>
      </div>
    </div>

    <div class="hero-actions">
      <button
        type="button"
        class="overview-btn overview-btn--dark"
        (click)="openServiceAdd()"
      >
        Add Service
      </button>
    </div>
  </section>

  <section class="kpi-grid">
    <article class="kpi-card kpi-card--primary">
      <div>
        <span>Total Services</span>

        <strong>
          {{ services.length }}
        </strong>

        <p>
          Total services currently configured across the selected salon view.
        </p>
      </div>
    </article>

    <article class="kpi-card">
      <div>
        <span>Assigned Salons</span>

        <strong>
          {{ assignedSalonCount }}
        </strong>

        <p>Selected salon locations with at least one service assigned.</p>
      </div>
    </article>

    <article class="kpi-card">
      <div>
        <span>Average Price</span>

        <strong>
          {{ toMoney(averageServicePrice) }}
        </strong>

        <p>Average service price across the selected catalog.</p>
      </div>
    </article>

    <article class="kpi-card">
      <div>
        <span>Average Duration</span>

        <strong> {{ averageServiceDuration }}m </strong>

        <p>Average booking duration for services in the selected salon view.</p>
      </div>
    </article>
  </section>

  <section class="panel">
    <header class="panel-head">
      <div>
        <span class="panel-kicker"> Service Directory </span>

        <h2>Service List</h2>

        <p>
          Search, edit, or delete services for the currently selected salons.
        </p>
      </div>

      <div class="panel-actions">
        <glo-control
          icon="search"
          placeholder="Search services or salons"
          classes="bg-gray-50"
          (valueChange)="onSearch($event)"
        >
        </glo-control>
      </div>
    </header>

    @if (!loading && services.length === 0) {
      <div class="empty-state">
        <div class="empty-icon">S</div>

        <strong> No services found </strong>

        <p>
          There are no services available for the currently selected salon view.
          Select another salon or add a new service.
        </p>

        <button
          type="button"
          class="overview-btn overview-btn--dark"
          (click)="openServiceAdd()"
        >
          Add Service
        </button>
      </div>
    } @else {
      <div class="table-shell">
        <table>
          <thead>
            <tr>
              <th>Service</th>
              <th>Salon</th>
              <th>Duration</th>
              <th>Price</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            @for (service of viewServices; track service.service_id) {
              <tr>
                <td>
                  <div class="service-cell">
                    <div class="service-avatar">
                      {{ getServiceInitial(service) }}
                    </div>

                    <div>
                      <strong>
                        {{ service.name || "Unnamed Service" }}
                      </strong>

                      <span>
                        Service ID:
                        {{ service.service_id }}
                      </span>
                    </div>
                  </div>
                </td>

                <td>
                  <span class="salon-name">
                    {{ getServiceValue(service, "salon_name") || "Unassigned" }}
                  </span>
                </td>

                <td>
                  <span class="duration-pill">
                    {{ getServiceDuration(service) }}
                    mins
                  </span>
                </td>

                <td>
                  <strong class="price-value">
                    {{ toMoney(service.price) }}
                  </strong>
                </td>

                <td>
                  <div class="row-actions">
                    <button type="button" (click)="openServiceEdit(service)">
                      Edit
                    </button>

                    <button
                      type="button"
                      class="danger"
                      (click)="deleteService(service)"
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <glo-pagination
        *ngIf="filteredServices.length > 0"
        [totalItems]="filteredServices.length"
        [currentPage]="currentPage"
        [itemsPerPage]="itemsPerPage"
        [itemsPerPageOptions]="[10, 20, 50, 100]"
        (currentPageChange)="onPageChange($event)"
        (itemsPerPageChange)="onItemsPerPageChange($event)"
      >
      </glo-pagination>
    }
  </section>

  <div class="mobile-action">
    <button
      type="button"
      class="overview-btn overview-btn--dark"
      (click)="openServiceAdd()"
    >
      Add Service
    </button>
  </div>
</div>
